import React, { Component } from 'react';
import '../settings.css';
import TagsByInput from '../../TagsAndChips/TagsByInput';
import ImageGalleryField from '../../../ImageGalleryField';
import { showNotification } from '../../../StatusNotification';

export class NewsSettings extends Component {
    static displayName = NewsSettings.name;

    constructor(props) {
        super(props);
        this.state = {
            newsConfigurations: null,
            removedTags: []
        };
        this.onTypeTagRemoval = this.onTypeTagRemoval.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newNewsConfigurations = this.state.newsConfigurations;
        newNewsConfigurations[e.target.name] = e.target.value;
        this.setState({ newsConfigurations: newNewsConfigurations });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let newsConfigurations = this.state.newsConfigurations;

        fetch('AdminSettings/UpdateNewsSettingsData', {
            method: 'POST',
            body: JSON.stringify(newsConfigurations),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    if (this.state.removedTags.length > 0) {
                        let removedTags = this.state.removedTags;
                        for (var i = 0; i < removedTags.length; i++) {
                            let tag = removedTags[i];
                            fetch('AdminNews/RemoveNewsTypeReference?typeToRemove=' + tag, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }
                            });
                        }
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        )
    }

    async onTypeTagRemoval(tag) {
        let removedTags = this.state.removedTags;
        removedTags.push(tag);
        this.setState({ removedTags: removedTags });
    }

    render() {
        let types;
        let defaultImage;

        let isNewsConfigurationsSet = false;
        if (this.state.newsConfigurations != null) {
            let newsConfigurations = this.state.newsConfigurations;
            types = newsConfigurations.types;
            defaultImage = newsConfigurations.defaultImage;

            isNewsConfigurationsSet = true;
        }

        let typesInput = isNewsConfigurationsSet ?
            <TagsByInput
                tags={types}
                tagUpdate={this.handleChange}
                name='types'
                isRequired={true}
                allowDuplicates={false}
                inputType='text'
                onTagRemoval={this.onTypeTagRemoval}
            /> : "";

        return (
            <div className='admin-settings--form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='grid-wrapper'>
                        <div className='dual-grid--offset'>
                            <div className='dual-grid__1-2 form-title'>
                                <h3>News</h3>
                            </div>

                            <label>Default Image: </label>
                            <input name='defaultImage' type='text' defaultValue={defaultImage} onChange={this.handleChange} required hidden />
                            <ImageGalleryField name='defaultImage' currentImageUrl={defaultImage} handleImageChange={this.handleChange} />

                            <label>Types: </label>
                            {typesInput}

                            <div className='dual-grid__1-2'>
                                <button type='submit' className='form-button'>Save</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetNewsSettingsData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            newsConfigurations: data
        });
    }
}

export default NewsSettings;
